const f = {
  color: {
    background: {
      overlay: "#1d2b36ff",
      surface: "#ffffffff",
      body: "#f1f3f5ff"
    },
    heading: {
      text: "#253642ff",
      textHover: "#1d2b36ff",
      icon: "#314351ff",
      iconHover: "#1d2b36ff"
    },
    border: "#c8d3deff",
    subheading: "#556575ff",
    close: "#314351ff",
    closeHover: "#253642ff"
  }
};
export {
  f as sidePanel
};
